import { LibraryType } from '@/apis/bujianStore/types'
import { From } from '@/data/constant'

export interface StoreSourceStrategy {
  key: 'awaitStore' | 'bujianStore'
  libraryType: LibraryType
  defaultFrom?: From
  filterType?: '1' // 1: '板件条码', 5: '订单id'
  itemType?: 'serve' | 'local'
  initialDone?: 'load' | 'done' | 'err'
}

export const awaitStoreSourceStrategy: StoreSourceStrategy = {
  key: 'awaitStore',
  libraryType: LibraryType.awaitStore,
  defaultFrom: From.BLUEN,
  itemType: 'serve',
  initialDone: 'load',
}

export const bujianStoreSourceStrategy: StoreSourceStrategy = {
  key: 'bujianStore',
  libraryType: LibraryType.bujianStore,
  defaultFrom: From.BLUEN,
  filterType: '1',
  initialDone: 'load',
}
